var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPlus2 = function SvgIcPlus2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0224 9.2513H10.7724C10.6891 9.2513 10.6307 9.18464 10.6307 9.10964V2.85964C10.6224 2.4763 10.3141 2.16797 9.93906 2.16797C9.56406 2.16797 9.2474 2.4763 9.2474 2.85964V9.10964C9.2474 9.19297 9.18073 9.2513 9.10573 9.2513H2.85573C2.4724 9.2513 2.16406 9.55964 2.16406 9.94297C2.16406 10.3263 2.4724 10.6346 2.85573 10.6346H9.10573C9.18906 10.6346 9.2474 10.7013 9.2474 10.7763V17.0263C9.2474 17.4096 9.55573 17.718 9.93906 17.718C10.3224 17.718 10.6307 17.4096 10.6307 17.0263V10.7763C10.6307 10.693 10.6974 10.6346 10.7724 10.6346H17.0224C17.4057 10.6346 17.7141 10.3263 17.7141 9.94297C17.7141 9.55964 17.3974 9.2513 17.0224 9.2513Z",
    fill: "#286DF0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPlus2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/ic_plus_2.97a37700.svg";
export { ForwardRef as ReactComponent };